export default __webpack_public_path__ + "static/media/quadroKevlar.a78080c7.png";